import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SyncEligibilityResultsType } from "@/domain/eligibilityResults";

import { EligibilityResultsApi } from "../api/eligibilityResultsApi";
import { EligibilityResultsQueryKeys } from "../queries/eligibilityResultsQueries";

export const useSyncEligibilityResultsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      householdId,
      body,
    }: {
      householdId: string;
      body: SyncEligibilityResultsType;
    }) => EligibilityResultsApi.syncEligibilityResults({ householdId, body }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: EligibilityResultsQueryKeys.all,
      }),
  });
};
